function initDigitalBrochureNavigation() {
  if (typeof jQuery === "undefined") {
    return;
  }

  const $ = jQuery;
  const $navGroups = $(".side-nav-bar .wp-block-group");

  if (!$navGroups.length) {
    return;
  }

  $(".side-nav-bar .nav-arrow, .side-nav-bar .nav-title").on("click", function () {
    $navGroups.removeClass("active rotate");
    $(this).closest(".wp-block-group").addClass("active rotate");
  });

  $(".brochure-start").on("click", function (event) {
    event.preventDefault();

    $navGroups.removeClass("active rotate");
    $navGroups.eq(0).addClass("active rotate");

    const href = $($(this).find(".wp-block-boldblocks-svg-block__inner")).attr(
      "href"
    );

    if (href && href.startsWith("#") && $(href).length) {
      $("html, body").animate(
        {
          scrollTop: $(href).offset().top,
        },
        500
      );
    }
  });

  const sections = $navGroups
    .map(function () {
      const href = $(this).find("a").first().attr("href");
      if (href && href.startsWith("#") && $(href).length) {
        return { navGroup: $(this), section: $(href) };
      }
      return null;
    })
    .get();

  $(window).on("scroll", function () {
    $navGroups.removeClass("active rotate");

    for (let i = 0; i < sections.length; i++) {
      if (sections[i] !== undefined) {
        const sectionTop = sections[i].section.offset().top;
        const sectionBottom = sectionTop + sections[i].section.height();
        const windowTop = $(window).scrollTop();

        if (windowTop >= sectionTop && windowTop <= sectionBottom) {
          sections[i].navGroup.addClass("active rotate");
          break;
        }
      }
    }
  });

  $('.side-nav-bar a[href^="#"]').on("click", function (event) {
    event.preventDefault();

    const target = this.hash;
    const $target = $(target);

    if ($target.length) {
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $target.offset().top,
          },
          900,
          "swing",
          function () {
            window.location.hash = target;
          }
        );
    }
  });
}

export default initDigitalBrochureNavigation;
